import { map } from 'rxjs/operators';
import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { DataService } from '../../../core/service/base/data.service';

import { APP_CONFIG, IAppConfig } from './../../../app.config';
import { Article } from './../../model/article';
import { RentalObjectCategory } from './../../model/const/enums';
import { Observable } from 'rxjs';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { MessageService } from '../../../core/service/message.service';
import { Appendix } from '../../model/appendix';

@Injectable()
export class AppendixService extends DataService<Appendix> {
  constructor(client: HttpClient, @Inject(APP_CONFIG) config: IAppConfig, messageService: MessageService, progressBar: ProgressBarService) {
    super(client, config, messageService, Appendix, progressBar, 'appendix');
  }

  preview(id: string): Observable<any> {
    return this.getPdf(`preview/${id}`);
  }
}
